import { Fragment, memo, useMemo } from "react";
import { FloatingFocusManager, FloatingPortal } from "@floating-ui/react";

import { usePopover } from "./Popover";

import type { ReactNode } from "react";
import type { PopoverRenderPropArg } from "./Popover";

export interface PopoverPanelProps {
  children?: ReactNode | ((props: PopoverRenderPropArg) => ReactNode);
}

export const PopoverPanel = memo(function PopoverPanel({
  children,
}: PopoverPanelProps) {
  const { isMounted, close, getPanelProps, getFloatingProps, floatingContext } =
    usePopover();

  const render = useMemo(() => {
    if (typeof children === "function") {
      return children({ close });
    }

    return children;
  }, [children, close]);

  if (!isMounted || !floatingContext) return null;

  const Wrapper =
    floatingContext.strategy === "fixed" ? FloatingPortal : Fragment;

  return (
    <Wrapper>
      <FloatingFocusManager context={floatingContext} modal={false}>
        <div className="PopoverFloating" {...getFloatingProps()}>
          <div className="PopoverPanel" {...getPanelProps()}>
            {render}
          </div>
        </div>
      </FloatingFocusManager>
    </Wrapper>
  );
});
